import React, { useState } from "react";
import FieldDropdown from "../../../components/common/InputField/FieldDropdown";
import { ACCOUNT_POPUP_MUTED_PANEL } from "../../../components/BusinessDashboard/accountPopupFields";
import {
  AdminDetailFieldLabel,
  AdminSupportingText,
  AdminHeaderAction,
  adminWizardDropdownClasses,
  adminWizardTextareaClasses,
} from "../../AdminDashboard/shared/adminUx";
import {
  BUSINESS_WIZARD_CONTENT_WIDE_CLASS,
  BUSINESS_FORM_ACTION_ROW_END_CLASS,
} from "../shared/businessLayoutSpec";

const BusinessDeactivation = () => {
  const [selectedReason, setSelectedReason] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [confirmed, setConfirmed] = useState(false);

  const reasonOptions = [
    { label: "Business needs have changed.", value: "Business needs have changed." },
    { label: "Found services through another platform.", value: "Found services through another platform." },
    { label: "Expectations not met by Trades Poster.", value: "Expectations not met by Trades Poster." },
    { label: "Experienced difficulties with platform usability.", value: "Experienced difficulties with platform usability." },
    { label: "Concerns about business data privacy.", value: "Concerns about business data privacy." },
    { label: "Others", value: "Others" },
  ];

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div className={`${BUSINESS_WIZARD_CONTENT_WIDE_CLASS} space-y-5`}>
        <div className="space-y-1">
          <AdminDetailFieldLabel>Reason for deactivation</AdminDetailFieldLabel>
          <FieldDropdown
            surface="muted"
            fullWidth
            value={selectedReason ?? ""}
            onChange={(e) => setSelectedReason(e.value)}
            options={reasonOptions}
            placeholder="Select the primary reason for deactivation"
            className={adminWizardDropdownClasses(false, true)}
            panelClassName={ACCOUNT_POPUP_MUTED_PANEL}
            showClear={false}
            appendTo={null}
          />
        </div>
        <div className="space-y-1">
          <AdminDetailFieldLabel htmlFor="deactivation-feedback-page">
            Additional feedback
          </AdminDetailFieldLabel>
          <textarea
            id="deactivation-feedback-page"
            placeholder="Your feedback is crucial to us. If you have any additional thoughts about your experience, challenges faced, ideas for platform improvement, or positive aspects you'd like to mention, we welcome your input."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            rows={4}
            className={`${adminWizardTextareaClasses(false)} lg:bg-pastalblue`}
            style={{ resize: "none" }}
          />
        </div>
        <div>
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              id="deactivation-confirm-page"
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
              className="size-4 mt-0.5 rounded border-mediumgray text-primaryblue focus:ring-primaryblue"
            />
            <div>
              <AdminSupportingText className="text-offblack block font-medium">
                Account deactivation confirmation
              </AdminSupportingText>
              <AdminSupportingText className="text-mediumgray mt-2 block">
                Confirm your request to deactivate your business account. This will cease all
                current engagements with service providers on Trades Poster, and all saved
                preferences or business listings will be permanently removed.
              </AdminSupportingText>
            </div>
          </label>
        </div>
      </div>
      <div className={`${BUSINESS_WIZARD_CONTENT_WIDE_CLASS} ${BUSINESS_FORM_ACTION_ROW_END_CLASS}`}>
        <AdminHeaderAction
          type="button"
          className="!bg-alertred hover:opacity-90"
          disabled={!confirmed}
        >
          Deactivate
        </AdminHeaderAction>
      </div>
    </form>
  );
};

export default BusinessDeactivation;
